import { ApplicationWithDetails } from '../../../types';
import { PrinterDetails_eng } from './PrinterDetails/PrinterDetails_eng';
import { PrinterInstructions_eng } from './PrinterInstructions/PrinterInstructions_eng';
import { PrinterKnowledgeBase_eng } from './PrinterKnowledgeBase/PrinterKnowledgeBase_eng';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const Printer_eng: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406ECD74`,
	name: `Dodo Printer`,
	description: `App for printing labels with thermal printer.`,
	descriptionLong: `App supports label printing at the packaging station and cold kitchen.\nLabel printing simplifies the packaging process, since there is no need to fill in the order number manually. Label on the package contains order number and names of sauces for couriers, it also provides customers with full information about ingredients and production/expiration dates in accordance with the law. Vertical label shows information about quality control. In addition to this, one can set up a template and add a QR-code with marketing information or feedback form. Label printer replaces manual labeling, which helps to save time and reduce the number of human errors, such as unreadable expiration dates. Employees do not have to waste time checking the table of ingredients, because the printer automatically takes information on expiration dates from standards.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/printer/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/printer/bgr`,
	sliders: [
		`https://cdn.dodostatic.net/static/marketplace/printer/slider1-en`,
		`https://cdn.dodostatic.net/static/marketplace/printer/slider2-en`,
		`https://cdn.dodostatic.net/static/marketplace/printer/slider3-en`,
		`https://cdn.dodostatic.net/static/marketplace/printer/slider4`,
		`https://cdn.dodostatic.net/static/marketplace/printer/slider5`,
		// 'https://cdn.dodostatic.net/static/marketplace/printer/slider6',
	],
	// eslint-disable-next-line sonarjs/no-duplicate-string
	webSiteUrl: ``,
	supportUrl: `https://play.google.com/store/apps/details?id=com.dodopizza.foregroundprinter&hl=ru&gl=US`,
	redirectUrl: ``,
	contactEmail: `support@dodopizza.com`,
	supportEmail: ``,
	categories: [`Production`, `Label printer`, `Cold kitchen`, `Packaging`],
	countries: [`All`],
	languages: [`Русский`, `English`],
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	type: `Application`,
	price: `Free`,
	version: `1.0`,
	developer: `Dodo Brands`,
	plans: null,
	instructions: PrinterInstructions_eng,
	details: PrinterDetails_eng,
	knowledgeBase: PrinterKnowledgeBase_eng,
	isExternal: false,
	showInstruction: false,
	versionHistory: null,
	goToApp: false,
};
